<template>
  <div>
    <div v-if="arraySelected.length > 0" class="mb-3">
      <template v-for="(item, index) in arraySelected">
        <div :key="index">
          <v-chip
            label
            color="primary"
            text-color="white"
            :close="index + 1 === arraySelected.length"
            @input="handleRemove(item.key)"
            >{{ item.value }}</v-chip
          >
          <em v-if="index + 1 < arraySelected.length" class="fas fa-chevron-right mx-1" />
        </div>
      </template>
    </div>
    <template v-if="arraySelected.length < 4">
      <div class="my-3">
        <v-text-field
          v-model="search"
          prepend-inner-icon="search"
          outline
          type="text"
          :placeholder="$t('Search')"
          class="default-input"
          maxlength="255"
          name="search"
          hide-details
        />
      </div>
      <div v-if="filterOptions.length > 0">
        <v-list class="py-0">
          <v-list-tile
            v-for="(item, index) in filterOptions"
            :key="index"
            active-class="grey lighten-4 indigo--text"
            style="border: 1px solid #eee"
            class="mb-2"
            @click="handleSelectedOption(item, currentLevel)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ item }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <em class="fas fa-chevron-right" />
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </div>
      <div v-else class="my-4 text-xs-center">{{ $t('No data') }}</div>
    </template>
  </div>
</template>

<script>
import { TTB_WRAP_UP } from '@/constants/ttb.js'

export default {
  props: ['value'],
  data() {
    return {
      currentLevel: 1,
      selected: {},
      wrapUpOptions: [],
      arraySelected: [],
      search: ''
    }
  },
  computed: {
    ttbWrapUpData() {
      return TTB_WRAP_UP
    },
    filterOptions() {
      let options = []

      if (this.search) {
        options = this.wrapUpOptions.filter((option) =>
          option.toLowerCase().includes(this.search.toLowerCase())
        )
      } else {
        options = this.wrapUpOptions
      }
      return options
    },
    currentSelected() {
      return this.selected
    }
  },
  watch: {
    currentLevel(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.handleSetWrapUpOptions()
      }
    }
  },
  mounted() {
    this.initWrapUp()
  },
  methods: {
    initWrapUp() {
      const vm = this
      try {
        const tempData = vm.value
        if (tempData) {
          const splitData = tempData.split('||')
          const tempObj = {}

          splitData.forEach((val, index) => {
            Object.assign(tempObj, { [`level_${index + 1}`]: val.trim() })
          })

          this.selected = tempObj
          this.currentLevel = splitData.length + 1
          this.transformValue()
        }

        this.handleSetWrapUpOptions()
      } catch (error) {
        console.error(error)
      }
    },
    handleSetWrapUpOptions() {
      const vm = this
      try {
        let options = []
        const level = parseInt(vm.currentLevel)

        if (level === 1) {
          options = vm.ttbWrapUpData.map((item) => item.level_1)
        } else {
          const filterCurrentData = vm.ttbWrapUpData.find(
            (item) => item.level_1 === vm.selected.level_1
          )

          if (filterCurrentData) {
            if (level === 2) {
              options = filterCurrentData.level_2.map((el) => el.title)
            } else if (level === 3 || level === 4) {
              const tempLevel2Data = filterCurrentData.level_2
              const objSelectedLv2 = tempLevel2Data.find(
                (item) => item.title === vm.selected.level_2
              )

              if (level === 3 && objSelectedLv2.level_3) {
                options = objSelectedLv2.level_3.map((el) => el.title)
              } else if (level === 4) {
                const tempLevel3Data = objSelectedLv2.level_3
                const objSelectedLv3 = tempLevel3Data.find(
                  (item) => item.title === vm.selected.level_3
                )
                options = objSelectedLv3.level_4.map((el) => el.title)
              } else {
                options = []
              }
            } else {
              options = []
            }
          } else {
            options = []
          }
        }
        vm.wrapUpOptions = options
      } catch (error) {
        console.error(error)
      }
    },
    handleSelectedOption(value, level) {
      const vm = this
      try {
        vm.search = ''
        let tempSelected = vm.selected
        Object.assign(tempSelected, { [`level_${level}`]: value })
        vm.selected = tempSelected

        if (this.isTwoLevelWrapUp && parseInt(level) === 2) {
          vm.$emit('onUpdateWrapUpData', value)
        }
        if (parseInt(level) === 4) {
          vm.$emit('onUpdateWrapUpData', value)
        }

        vm.currentLevel++
        vm.transformValue()
      } catch (error) {
        console.error(error)
      }
    },
    transformValue() {
      let selected = []
      let emitText = ''

      if (Object.keys(this.selected).length > 0) {
        Object.keys(this.selected).forEach((item, index) => {
          selected.push({
            key: item,
            value: this.selected[item]
          })

          if (index > 0) {
            emitText = emitText.concat(' || ')
          }
          emitText = emitText.concat(this.selected[item])
        })
      }
      this.arraySelected = selected
      this.$emit('input', emitText)
    },
    handleRemove(key) {
      const vm = this
      try {
        let tempSelected = vm.selected
        delete tempSelected[key]
        vm.selected = tempSelected

        const level = key.replace('level_', '')
        vm.currentLevel = level
        vm.transformValue()
        vm.$emit('onUpdateWrapUpData', null)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/ttb/WrapUpManage.vue